import { Routes } from '@angular/router';
import { layoutRoutes } from './layout/layout.routes';

export const appRoutes: Routes = [...layoutRoutes];
